import { useNavigate } from 'react-router'
import {Input} from 'antd'
import dayjs from 'dayjs'
import {
  Form, FormItem, DatePicker,
  Box, Button,
} from 'common/components'
import {formatDate} from 'common/helpers'
import {FIELD_RULES} from 'common/constants'
import {useCreateRequest} from '../../requests/api.default'
import { useUpdateDefaultRequest } from 'modules/request/api.default'

const {TextArea} = Input

interface VariationFormProps {
  type: 'start' | 'stop'
  projectUuid: string
  initialValues?: any
  onClose: () => void
}

export default function VariationDefaultForm({
  initialValues,
  type,
  projectUuid,
  onClose,
}: VariationFormProps) {
  const navigate = useNavigate()
  const {mutate: createRequest, isMutating:isCreating} = useCreateRequest((newReq:any) => {
    onClose?.()
    navigate(`/requests/default${!!newReq?.uuid ? ('/' + newReq.uuid) : ''}`)
  })
  const {mutate: updateRequest, isMutating:isUpdating} = useUpdateDefaultRequest(initialValues?.uuid, () => {
    onClose?.()
  })
  const isMutating = isCreating || isUpdating

  const handleFinish = (values: any) => {
    const newValues = (type === 'start') ? {
      type: "Start",
      projectUuid,
      startDate: formatDate(dayjs(values.startDate).format('YYYY-MM-DD'), 'server'),
      comment: values.comment,
    } : {
      type: "Stop",
      projectUuid,
      startDate: formatDate(dayjs(values.startDate).format('YYYY-MM-DD'), 'server'),
      endDate: formatDate(dayjs(values.endDate).format('YYYY-MM-DD'), 'server'),
      comment: values.comment,
    }

    // console.log(createNew)
    // console.log(newValues)
    // return 
    if (!initialValues?.uuid) {
      createRequest(newValues)
    } else {
      // console.log(initialValues?.uuid)
      // console.log(newValues)
      updateRequest(newValues)
    }
  }

  // console.log(type)
  // console.log(initialValues)
  const newInitialValue = !initialValues ? {
    startDate: dayjs().toDate()
  } : {
    endDate: (type === 'stop') ? dayjs().toDate() : undefined,
    ...initialValues,
  }

  return (
    <Form initialValues={newInitialValue} onFinish={handleFinish} >
      <FormItem
        name="startDate"
        label='Start Date'
        rules={FIELD_RULES}
      >
        <DatePicker
          disabled={type === 'stop'}
          disabledDate={
            (type === 'stop') ?  () => (false) :
            (d:Date) => (dayjs(d).isAfter(dayjs(), 'day'))
          }
        />
      </FormItem>
      { (type === 'stop') && 
        <FormItem
          name="endDate"
          label='Stop Date'
          rules={FIELD_RULES}
        >
          <DatePicker
            disabledDate={
              (d:Date) => (!dayjs(d).isSame(dayjs(), 'day'))
            }
          />
        </FormItem>
      }
      <FormItem
        name="comment"
        label="Comments for review"
        rules={FIELD_RULES}
      >
        <TextArea rows={5} />
      </FormItem>
      <Box align="center" mt={12}>
        <Button htmlType="submit" loading={isMutating}>
          confirm
        </Button>
      </Box>
    </Form>
  )
}
